/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Public_DescInputs */



/**
* | output |
* | --- |
* | "full standings visible" |
*
* @param {Og_Cfg_Public_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_public_desc = /** @type {((inputs?: Og_Cfg_Public_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Public_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("classement complet visible")
	if (locale === "es") return /** @type {LocalizedString} */ ("clasificación completa visible")
	if (locale === "pt") return /** @type {LocalizedString} */ ("classificação completa visível")
	if (locale === "it") return /** @type {LocalizedString} */ ("classifica completa visibile")
	return /** @type {LocalizedString} */ ("full standings visible")
});